import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { Typography } from '@/shared/components/atoms';
import TooltipLite from '@/shared/components/atoms/TooltipLite';
import { IGeneral } from '@/shared/types';

import EditIcon from '~/images/shared/edit.svg';
import MoreIcon from '~/images/shared/HorizontalHollowDots.svg';
import TrashIcon from '~/images/shared/Trash.svg';

const EditAndDelete: React.FC<{
  onEditClick?: IGeneral.IVoidFunction;
  onDeleteClick?: IGeneral.IVoidFunction;
  deleteText?: string;
  deleteDisabledMessage?: string;
  bordered?: boolean;
  id?: number;
}> = ({
  onDeleteClick,
  onEditClick,
  deleteText,
  deleteDisabledMessage,
  bordered,
  id,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className='flex items-center gap-16 text-primary-default'
      onClick={(e) => e.preventDefault()}
    >
      {onEditClick && (
        <div
          className={classNames(
            'flex cursor-pointer items-center gap-4 text-primary-default',
            bordered &&
              'rounded-[12px] border-xs border-outline-default px-16 py-8'
          )}
          onClick={onEditClick}
        >
          <EditIcon width='25' height='25' />
          {bordered && <Typography weight='medium'>{t('edit')}</Typography>}
        </div>
      )}
      {onDeleteClick && (
        <TooltipLite
          eventToggle={!deleteDisabledMessage ? 'onClick' : undefined}
          disabled={!!deleteDisabledMessage}
          disabledMessage={deleteDisabledMessage}
          id={id}
          content={
            <div
              className='flex cursor-pointer items-center gap-8 px-8 py-8'
              onClick={onDeleteClick}
            >
              <TrashIcon width='24' height='24' />
              <Typography variant='subtitle2' className='text-error-400'>
                {t(deleteText ?? 'delete')}
              </Typography>
            </div>
          }
        >
          <MoreIcon />
        </TooltipLite>
      )}
    </div>
  );
};

export default EditAndDelete;
